import { v4 as uuidv4 } from 'uuid';

export default class InputData {
    id = uuidv4()
    x = null
    y = null
    width = null
    height = null
    angle = null
    scaleX = null
    scaleY = null
    url = null

    constructor(data = {}) {
        this.setData(data)
    }

    setData(data) {
        [
            'x',
            'y',
            'width',
            'height',
            'angle',
            'scaleX',
            'scaleY',
            'id',
        ].forEach((key) => {
            this[key] = data?.[key] !== undefined ? data[key] : this[key]
        })
    }

    getId() {
        return this.id
    }

    get(key, defaultValue = null) {
        return this[key] || defaultValue
    }

    _toString() {
        return JSON.stringify(this)
    }
}